import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-cancellation-policy',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './cancellation-policy.component.html'
})
export class CancellationPolicyComponent {}
